/**
 * [FUNDAMENT G/H/I/J/K 2026-09-02, §6.1] JEDYNE miejsce doczepiania warstw API modułów do apiService.
 *
 * apiService.js importuje wyłącznie `attachApiModules` i rozlewa jego wynik do wspólnego obiektu — dzięki temu
 * apiService.js jest ZAMKNIĘTY, a każdy moduł pisze we własnym pliku src/api/modules/<modul>.js.
 * Lista poniżej jest kompletna dla pakietu (9 modułów); nowy plik modułu = jedna linia tutaj.
 */
import * as career from "./career";
import * as goals from "./goals";
import * as jobOffers from "./jobOffers";
import * as deptDocs from "./deptDocs";
import * as hrDocs from "./hrDocs";
import * as onboarding from "./onboarding";
import * as offboarding from "./offboarding";
import * as hrProcess from "./hrProcess";
import * as rozscalenie from "./rozscalenie";
// [S4 / S13, 2026-09-14] Stopki e-mail (mapowanie per spółka, wersje, archiwum) i zmiany masowe raportu pracy zdalnej.
import * as stopki from "./stopki";
import * as pracaZdalna from "./pracaZdalna";
// [S20 2026-09-14] Reakcje (emoji) pod wiadomościami czatu Teams.
import * as teamsReakcje from "./teamsReakcje";
// [S23 2026-09-14] Raport daily zapisywany przez serwer z kontrolą modułu kolejki.
import * as raportDaily from "./raportDaily";
// [S11 2026-09-14] Zasoby sieciowe przypisane do działu (/moj-dzial/uprawnienia).
import * as zasobyDzialu from "./zasobyDzialu";
// [S15 / S16 2026-09-14] Nazwiska wskazanych osób w wyborze odbiorców i ponowne przeczytanie komunikatu w centrum powiadomień.
import * as osoby from "./osoby";
import * as komunikaty from "./komunikaty";
// [polecenie właściciela 2026-09-14] Pakiety szkoleń e-learningowych przypisywane z tytułu zatrudnienia.
import * as pakietySzkolen from "./pakietySzkolen";
// [2026-09-14] Publiczne linki do szkoleń: część administracyjna (JWT) i publiczna (bez ciasteczek, bez interceptorów 401).
import * as publiczneSzkolenia from "./publiczneSzkolenia";

// [polecenie właściciela 2026-09-14] Publiczna strona podpisu online umów (/podpis/:token — bez logowania).
import * as podpisPubliczny from "./podpisPubliczny";
// [AX-2 / P3 2026-09-18] Analityka CPM projektu (GET pl-projects/{id}/analityka) — Gantt ze ścieżką krytyczną.
import * as plAnalityka from "./plAnalityka";
// [polecenie właściciela 2026-09-28] /itam/teamviewer — widok urządzeń per grupa, „Dodaj urządzenie” i „Edytuj”.
import * as teamviewerUrzadzenia from "./teamviewerUrzadzenia";
// [polecenie właściciela 2026-09-30, A] Kandydaci do pola wyboru osoby wniosku HR — cały dział osoby wniosku (z komórkami).
import * as wnioskiOsoby from "./wnioskiOsoby";
// [polecenie właściciela 2026-09-30, B3] Odczyt powiadomień po obiekcie (PUT notifications/read-for-object).
import * as powiadomieniaObiektu from "./powiadomieniaObiektu";
// [polecenie właściciela 2026-09-30, D] Skrzynka zewnętrzna — wiadomości spoza domen spółek czekają na decyzję.
import * as skrzynkaZewnetrzna from "./skrzynkaZewnetrzna";
// [polecenie właściciela 2026-09-30, G] Baza wiedzy od nowa — adres z tematu, obowiązek zapoznania, procedury.
import * as bazaWiedzy from "./bazaWiedzy";
// [polecenie właściciela 2026-09-30, E2] Procedury modułu obsługi (sekcja w /admin/categories, strona procedur modułu).
import * as proceduryModulow from "./proceduryModulow";
// [polecenie właściciela 2026-09-30, E1/F] Kategorie główne i automapowanie zgłoszeń (podgląd + zastosuj).
import * as kategorieGlowne from "./kategorieGlowne";
// [P13b, polecenie właściciela 2026-10-01] Funkcje administracyjne modułu (filtr domen, konfiguracja raportów) — posiadacze.
import * as funkcjeAdminaModulu from "./funkcjeAdminaModulu";
// [polecenie właściciela 2026-10-01, projekt „Cykl życia na pasku”] „Czego brakuje” — macierz obszarów × spółki (Procedury i bezpieczeństwo).
import * as politykiStrona from "./politykiStrona";
// [polecenie właściciela 2026-10-01] Tablica „Wsparcie <moduł>” — zgłoszenia na działowym Kanbanie (/kanban?tablica=<kod>).
import * as tablicaWsparcia from "./tablicaWsparcia";
// [polecenie właściciela 2026-10-02] Tryb testowy powiadomień per spółka (baner, komunikat na /admin, suwak przy firmie).
import * as trybTestowy from "./trybTestowy";
// [polecenie właściciela 2026-10-02] Słownik SAP: podpowiedź fraz reguły, okno „Uprawnienia modułu”, grupy nad kartami konfiguratora.
import * as slownikDz from "./slownikDz";
// [polecenie właściciela 2026-10-02] Przycisk „SAP” — zgłoszenie jednym kliknięciem do kategorii „Inne zgłoszenie SAP”.
import * as zgloszeniaSap from "./zgloszeniaSap";
// [polecenie właściciela 2026-10-02, EA-1] Materiały procedury: import PDF / Word / zrzutów, biblioteka multimedialna, podglądy.
import * as politykiMaterialy from "./politykiMaterialy";
// [polecenie właściciela 2026-10-02, EA-1 → EA-4/EA-5] Faktury ITAM: sprawdzenie duplikatu i odłożona ewidencja po zapisie.
import * as fakturyEa from "./fakturyEa";
// [DZ-8, polecenie właściciela 2026-10-03] Rozdział modułów IT/HR: „Przenieś do modułu…” i lista zastanych rozjazdów.
import * as przeniesienieModulu from "./przeniesienieModulu";
// [polecenie właściciela 2026-10-03] Import haseł z pliku Excel do banków działów (/admin/password-manager).
import * as sejfImport from "./sejfImport";
// [polecenie właściciela 2026-10-04] Lista dozwolonych logowań („whitelista”) per firma — sekcja w /admin/integrations.
import * as listaLogowan from "./listaLogowan";

export const API_MODULES = Object.freeze({
    career, goals, jobOffers, deptDocs, hrDocs, onboarding, offboarding, hrProcess, rozscalenie,
    stopki, pracaZdalna, teamsReakcje, raportDaily, zasobyDzialu, osoby, komunikaty, pakietySzkolen, publiczneSzkolenia, podpisPubliczny,
    plAnalityka, teamviewerUrzadzenia, wnioskiOsoby, powiadomieniaObiektu, skrzynkaZewnetrzna, bazaWiedzy,
    proceduryModulow, kategorieGlowne, funkcjeAdminaModulu, politykiStrona, tablicaWsparcia, trybTestowy,
    slownikDz, zgloszeniaSap, politykiMaterialy, fakturyEa, przeniesienieModulu,
    sejfImport, listaLogowan,
});

/**
 * Scala metody wszystkich modułów w jeden obiekt.
 * Kolizja nazw między modułami (albo z metodami rdzenia przekazanymi w `reserved`) rzuca od razu —
 * cicha nadpisana metoda to dokładnie ten rodzaj błędu, który zabrał kiedyś getUsers z apiService.js.
 * @param {import("axios").AxiosInstance} api
 * @param {Iterable<string>} [reserved] nazwy metod rdzenia apiService.js, których moduł nie może przesłonić
 */
export function attachApiModules(api, reserved = []) {
    const taken = new Map();
    for (const name of reserved) taken.set(name, "apiService.js");
    const merged = {};
    for (const [moduleName, mod] of Object.entries(API_MODULES)) {
        if (typeof mod.attach !== "function") {
            throw new Error(`src/api/modules/${moduleName}.js nie eksportuje funkcji attach(api).`);
        }
        const methods = mod.attach(api) || {};
        for (const [methodName, fn] of Object.entries(methods)) {
            if (taken.has(methodName)) {
                throw new Error(
                    `Kolizja metody API "${methodName}": definiują ją ${taken.get(methodName)} i ${moduleName}.js. ` +
                    "Nazwy metod apiService muszą być unikalne — zmień nazwę w module.",
                );
            }
            taken.set(methodName, `${moduleName}.js`);
            merged[methodName] = fn;
        }
    }
    return merged;
}
